import React from 'react';
import PropTypes from 'prop-types';
import { Card, Icon } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import css from '../style.css';

function SerialNumberForm({ lastIndex }) {
  return (
    <div>
      <Card
        id="card-export-translation-exportOptions"
        cardStyle="positive"
        roundedBorder
        headerStart={
          <span className={css.cardHeader}>
            <Icon icon="gear">
              <FormattedMessage
                id="ui-plugin-inventory-templates.barcodeGeneralSettings.serialNumberOptions.card.label"
                defaultMessage="Serial number options"
              />
            </Icon>
          </span>
        }
      >
        <div>
          <strong>
            <FormattedMessage
              id="ui-plugin-inventory-templates.barcodeGeneralSettings.lastIndex"
              values={{ lastIndex }}
              defaultMessage="Last serial number is: {lastIndex}"
            />
          </strong>
        </div>
      </Card>
    </div>
  );
}

SerialNumberForm.propTypes = {
  lastIndex: PropTypes.string
};

export default SerialNumberForm;
